import { useNumberFormat, NUMBER_FORMATS } from '../numberFormat';

export default function NumberFormatToggle() {
  const [fmt, setFmt] = useNumberFormat();
  const next = fmt === 'us' ? 'ar' : 'us';

  return (
    <button
      type="button"
      onClick={() => setFmt(next)}
      aria-label={`Number format ${NUMBER_FORMATS[fmt].label} ${NUMBER_FORMATS[fmt].example}. Switch to ${NUMBER_FORMATS[next].label}`}
      title={`Switch to ${NUMBER_FORMATS[next].label} number format (${NUMBER_FORMATS[next].example})`}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
        padding: '7px 10px', borderRadius: 8, cursor: 'pointer',
        background: 'var(--card)', border: '1px solid var(--border)', color: 'var(--text2)',
        fontSize: 12, fontWeight: 600, whiteSpace: 'nowrap',
      }}
    >
      <span style={{ fontFamily: 'DM Mono,monospace' }}>{NUMBER_FORMATS[fmt].example}</span>
      {NUMBER_FORMATS[fmt].label}
    </button>
  );
}
